module.exports = "https://dynamic-faq.direct.canal-overseas.com/build/images/no-results.bdc165c9.png";